import { existsSync, readFileSync } from 'node:fs'
import { dirname, join } from 'node:path'
import { fileURLToPath } from 'node:url'

import { SDK_NAME, SDK_VERSION } from '../../generated/sdk-meta'

export type SdkMeta = {
  sdkName: string
  sdkVersion: string
  source: 'injected' | 'package.json' | 'unknown'
}

export function getSdkMeta(): SdkMeta {
  if (isNonEmptyString(SDK_NAME) && isNonEmptyString(SDK_VERSION)) {
    return {
      sdkName: SDK_NAME,
      sdkVersion: SDK_VERSION,
      source: 'injected',
    }
  }

  const fromPkg = tryReadPackageJson()
  if (fromPkg) {
    return {
      ...fromPkg,
      source: 'package.json',
    }
  }

  return {
    sdkName: 'unknown',
    sdkVersion: 'unknown',
    source: 'unknown',
  }
}

function isNonEmptyString(value: unknown): value is string {
  return typeof value === 'string' && value.length > 0
}

function findNearestPackageJson(startDir: string): string | null {
  let dir = startDir

  while (true) {
    const candidate = join(dir, 'package.json')
    if (existsSync(candidate)) {
      return candidate
    }

    const parent = dirname(dir)
    if (parent === dir) {
      return null
    }
    dir = parent
  }
}

function tryReadPackageJson(): Pick<SdkMeta, 'sdkName' | 'sdkVersion'> | null {
  try {
    const here = dirname(fileURLToPath(import.meta.url))
    const pkgPath = findNearestPackageJson(here)
    if (!pkgPath) return null

    const raw = readFileSync(pkgPath, 'utf8')
    const pkg = JSON.parse(raw) as { name?: unknown; version?: unknown }

    if (!isNonEmptyString(pkg.name) || !isNonEmptyString(pkg.version)) {
      return null
    }

    return {
      sdkName: pkg.name,
      sdkVersion: pkg.version,
    }
  } catch {
    return null
  }
}
